<!-- OVERLAY Section -->
<app-pop-over-panel-widget
    #popOverPanelWidget
    [dynamicTemplate]="dynamicTemplate"
    [event]="event()"
/>

<ng-template #dynamicTemplate>
    @if (eventData()?.eventType === ReportHistoryEventType.EMAILED) {
        <app-email-panel-view [userEmail]="eventData().data" />
    } @else if (
        eventData()?.eventType === ReportHistoryEventType.ASSETS ||
        eventData()?.eventType === ReportHistoryEventType.ASSET_AUTO_GENERATED
    ) {
        <app-assets-panel-view [assetsIds]="eventData().data" />
    }
</ng-template>

<!-- LIST Section -->
<app-base-list-wrapper [baseListComponent]="this">
    <ng-template #moreButtons let-table>
        <div class="flex gap-1 items-center">
            <!-- ReportHistoryEventType DropDown -->
            @if (!noDocumentPropertyFilterDropdown()) {
                <app-generic-enum-drop-down
                    enumName="ReportHistoryEventType"
                    [multiple]="true"
                    [whiteListFilter]="documentPropertiesWhiteListFilter"
                    placeholder="{{ 'common.status' | translate }}"
                    [closeOnSelect]="false"
                    [ngModel]="selectedDocumentProperties"
                    (valueChange)="this.selectedDocumentPropertyChanged($event)"
                    [overlayOptions]="{ mode: 'overlay' }"
                />
            }
        </div>
    </ng-template>

    <ng-template #preColHeaders let-data>
        <!-- todo, find a way to auto width -->
        <th [width]="90" pResizableColumn>{{ 'document.status-column' | translate }}</th>
    </ng-template>

    <ng-template
        #preCols
        let-rowData="rowData"
        let-rowIndex="rowIndex"
        let-editing="editing"
        let-table="table"
    >
        <td>
            <div class="flex items-center gap-1">
                <!-- Connection Section Icon -->
                <div class="clickable m-1">
                    <i [ngClass]="getIcon(rowData.reportHistoryEvent)"></i>
                </div>
                <!-- Members Section Icon -->
                @if (rowData?.employee) {
                    <phx-avatar [employee]="rowData.employee" size="small" shape="square" />
                }
            </div>
        </td>
    </ng-template>
</app-base-list-wrapper>
